import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import SimpleTable from "../../../components/SimpleTable";
import { useNavigate } from "react-router-dom";
import { BASE_URL, fetchData, postData } from "../../Utils/Baseurl";
import { Stack } from "@mui/material";
import CanAccess from "../../../components/permission/CanAccess";
import { useAuth } from "../../../context/AuthContext";
import MaterialSelect from "../../../components/MaterialSelect";
import MaterialInput from "../../../components/MaterialInput";
import axios from "axios";

const MeetingFilter = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { rolePermission, currentUser } = useAuth();
  const [projectNameOption, setProjectNameOption] = useState([]);
  const [data, setData] = useState({
    date: "",
    project_id: {},
  });

  useEffect(() => {
    fetchProjectData();
  }, []);
  useEffect(() => {
    getEmplyoeeList();
  }, [data]);

  const fetchProjectData = async () => {
    const formData = new FormData();
    formData.append("user_id", currentUser?.id);
    try {
      const res = await fetchData("/api/project/");
      if (res?.status) {
        setProjectNameOption(res?.data);
      } else {
        setProjectNameOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // emplyooee list
  const getEmplyoeeList = async () => {
    setIsLoading(true);
    const formData = new FormData();

    formData.append("project_id", data?.project_id?.value || "");

    formData.append("meeting_date", data?.date || "");

    try {
      const response = await postData("api/getmeeting/", formData);

      if (response?.status && Array.isArray(response.data)) {
        const data = response?.data?.map((item) => {
          const totalTasks = item?.tasks?.length || 0;
          const completedCount = item?.tasks?.filter(
            (task) => task.status === "Completed"
          ).length;

          return {
            ...item,
            taskList: totalTasks
              ? `${completedCount} / ${totalTasks}`
              : "0 / 0",
          };
        });

        setList(data);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setList([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Table column data
  const userColumns = [
    { header: "TITLE", key: "meeting_title" },
    { header: "PROJECT", key: "project" },
    { header: "CREATED BY", key: "meeting_host_name" },
    { header: "DATE", key: "meeting_date" },
    { header: "START TIME", key: "meeting_start_time" },
    { header: "END TIME", key: "meeting_end_time" },
    { header: "TASK", key: "taskList" },
    { header: "ACTION", key: "action" },
  ];
  // Table row data
  const userData = list.map((item) => ({
    id: item?.id,
    meeting_title: item?.meeting_title,
    meeting_host_name: item?.meeting_host_name,
    project: item?.project_name,
    meeting_start_time: item?.meeting_start_time,
    meeting_end_time: item?.meeting_end_time,
    meeting_date: item?.meeting_date,
    taskList: item?.taskList,
    allData: item,
  }));

  // edit function
  const employeeEdit = (id, row) => {
    navigate("/record-mom/add-meeting", {
      state: { data: row, type: "edit" },
    });
  };
  // view function
  const employeeView = (id, row) => {
    navigate("/record-mom/add-meeting", {
      state: { data: row, type: "view" },
    });
  };
  
  const handleDownloadPDF = async (id) => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(
        `${BASE_URL}api/meetingMOMPDFView/${id}/`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `Policy_mom.pdf`;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  // role permission for table
  const actionVisibility = {
    showEdit: CanAccess.can(rolePermission, "Employee Master", "Employee Edit"),
    showView: CanAccess.can(rolePermission, "Employee Master", "Employee View"),
    showDelete: CanAccess.can(
      rolePermission,
      "Employee Master",
      "Employee Delete"
    ),
  };

  const handleChange = (e, type) => {
    const add = { ...data };
    if (type === "select") {
      add["project_id"] = e;
    } else {
      add["date"] = e.target.value;
    }
    setData(add);
  };
  const clearFilter = () => {
    setData({
      date: "",
      project_id: {},
    });
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0} style={{ display: "block" }}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Meeting Filter
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the Meeting list here.
          </MaterialTypography>
        </Stack>
        <Stack>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Select Date
          </MaterialTypography>
          <MaterialInput
            type="date"
            value={data?.date}
            name="meetingTitle"
            placeholder="Enter Meeting Title"
            onChange={handleChange}
          />
        </Stack>

        <Stack>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Select Project
          </MaterialTypography>
          <MaterialSelect
            value={data?.project_id}
            name="meetingProject"
            onChange={(e) => handleChange(e, "select")}
            options={projectNameOption?.map((item) => {
              return {
                value: item?.id,
                label: item?.project_name,
              };
            })}
          />
        </Stack>
        <Stack>
          <button
            style={{
              border: "none",
              backgroundColor: "green",
              borderRadius: "5px",
              padding: "10px 20px",
              color: "white",
            }}
            onClick={clearFilter}
          >
            Clear
          </button>
        </Stack>
      </Stack>

      <SimpleTable
        columns={userColumns}
        data={userData}
        onEdit={employeeEdit}
        deleteAction={false}
        onView={employeeView}
        isLoading={isLoading}
        view={true}
        edit={false}
        download={true}
        onDownload={handleDownloadPDF}
        actionVisibility={actionVisibility}
      />
    </DashboardLayout>
  );
};

export default MeetingFilter;
